module.exports = __webpack_public_path__ + "img/icon-question-refresh.cbbcb619.svg";